import React, { useState } from "react";

import { Modal, SearchInput, Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import DepartmentList from "./DepartmentList";
import classes from "./CreateDepartmentChannel.scss";

const styles = {
  modalBodyStyle: {
    padding: "0",
    overflow: "hidden",
  },
  modalHeaderStyle: {
    padding: "16px 24px",
  },
  modalFooterStyle: {
    padding: "16px 24px",
    marginTop: "0",
  },
};

export const CreateDepartmentChannelModal = props => {
  const { onCloseModal } = props;
  const { t } = useI18n(["common"]);

  const [searchText, setSearchText] = useState();
  const scrollContainerRef = React.createRef();

  const headerTitle = `${t("common:search_for_label", {
    label: t("common:department"),
  })}...`;

  return (
    <Modal
      height="600px"
      width="480px"
      dsVersion="2.0"
      hasOverlay
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onCloseModal}
      isOpen
    >
      <Modal.Header
        title={t("common:start_department_channel")}
        isClosable
        style={styles.modalHeaderStyle}
      />

      <Modal.Body style={styles.modalBodyStyle}>
        <div className={classes.modalBodyContainer}>
          <div className={classes.searchBarContainer}>
            <SearchInput
              dsVersion="2.0"
              size="medium"
              focusSearchBySlash
              placeholder={headerTitle}
              onChange={setSearchText}
            />
          </div>
          <div
            className={classes.departmentListContainer}
            ref={scrollContainerRef}
          >
            <DepartmentList
              searchText={searchText}
              onCloseModal={onCloseModal}
              containerRef={scrollContainerRef}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const CreateDepartmentChannelButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { t } = useI18n(["common"]);
  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const onOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      {isModalOpen ? (
        <CreateDepartmentChannelModal onCloseModal={onCloseModal} />
      ) : null}

      <Button
        variant="primary"
        type="fill"
        size="medium"
        onClick={onOpenModal}
        dsVersion="2.0"
      >
        {t("common:create_a_with_label", {
          label: t("common:department_channel"),
        })}
      </Button>
    </>
  );
};

export default CreateDepartmentChannelButton;
